import { ButtonTitle } from "features/shared/styles/typography/ButtonTitle.styled";
import styled from "styled-components";

const HeaderLink = styled.a`
  text-decoration: none;
  padding: 0;
  height: 100%;
  display: flex;
  align-items: center;

  ${ButtonTitle} {
    color: ${({ theme }) => theme.colors.primary1};
  }

  @media all and (max-width: ${({ theme }) => theme.mobileBreakingPoint}) {
    display: none;
  }
`;

export default HeaderLink;
